import { createContext, useContext } from "react"

export const InvitationContext = createContext<{ firstName: string | null }>({
  firstName: null,
})

export function useInvitation() {
  return useContext(InvitationContext)
}
